/* eslint-disable react-hooks/exhaustive-deps */
import { Box, FormControl, InputLabel, MenuItem, Paper, Select, Typography, useTheme } from "@mui/material"
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import { useSelector } from "react-redux";




const BookingStatus = () => {
    const theme = useTheme();
    const formik = useFormikContext();

    const verificationBooking = useSelector((state) => state.verificationBooking);
    


    const [mainData, setMainData] = useState([])

    useEffect(() => {
        if (verificationBooking.loading === 'succeeded') {


            if (verificationBooking.data.bookingStatusList.length !== 0 && formik.values?.bookingStatus?.id === undefined) {

                    formik.setFieldValue('bookingStatus', verificationBooking.data.bookingStatusList[0])

                setMainData(verificationBooking.data.bookingStatusList)

            } else {
                let filter = verificationBooking.data.bookingStatusList;
                setMainData(filter)

            }


        }

    }, [verificationBooking.loading])





   



    const noOfDays = () => {


        try {
            const date1 = new Date(formik?.values?.entryDate || new Date().toISOString().substr(0, 10));
            const date2 = new Date(new Date().toISOString().substr(0, 10));
            const Difference_In_Time = date2.getTime() - date1.getTime();
            const Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
            return Difference_In_Days;
        } catch (error) {

        }
        return 0;
    }




    return (
        <Paper elevation={3} sx={{
                   borderRadius: 4,
                   boxShadow: '0 4px 24px 0 rgba(11, 60, 93, 0.10)',
                   bgcolor: theme.palette.background.paper,
                   p: { xs: 2, md: 4 },
                 
               
                   maxWidth: 1200,
                   mx: 'auto',
                 }}>
            <Box display='flex' flexDirection={{ xs: 'column', md: 'row' }} justifyContent='space-between' alignItems={{ xs: 'flex-start', md: 'center' }} gap={2}>
                <FormControl sx={{
                    width: { xs: '100%', md: '380px' },
                    height: '50px',
                    bgcolor: theme.palette.grey[100],
                    borderRadius: 2,
                    boxShadow: '0 1px 4px 0 rgba(11, 60, 93, 0.06)',
                }}>

                    <InputLabel sx={{ color: theme.palette.primary.main, fontWeight: 700 }}>{t("carStatus")}</InputLabel>

                    <Select
                        disabled={true}
                        value={formik.values.bookingStatus?.id || ''}
                        onChange={(event) => {
                            const selectedValue = event.target.value;
                            const selectedOption = mainData.find((item) => item.id === selectedValue);
                            formik.setFieldValue('bookingStatus', selectedOption || null);
                        }}
                        name='bookingStatus'
                        sx={{
                            bgcolor: theme.palette.background.paper,
                            borderRadius: 2,
                            fontWeight: 700,
                            color: theme.palette.primary.main,
                            '& .MuiSelect-icon': { color: theme.palette.secondary.main },
                        }}
                    >
                        {mainData && mainData.map(item =>
                            <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                        )}
                    </Select>
                </FormControl>
                <Box sx={{
                    display: "flex",
                    alignItems: 'baseline',
                    bgcolor: theme.palette.grey[100],
                    borderRadius: 2,
                    px: 3,
                    py: 1,
                    boxShadow: '0 1px 4px 0 rgba(11, 60, 93, 0.06)',
                    minWidth: 120,
                    justifyContent: 'center',
                }}>
                    <Typography variant="h2" sx={{
                        fontWeight: 'bolder',
                        color: theme.palette.primary.main,
                        fontSize: { xs: 28, md: 36 },
                        mr: 1,
                    }} >
                        {noOfDays()}
                    </Typography>
                    <Typography variant="h6" sx={{
                        fontWeight: 'bolder',
                        color: theme.palette.secondary.main,
                        fontSize: { xs: 16, md: 20 },
                    }} >
                        Days
                    </Typography>
                </Box>
            </Box>
        </Paper >
    )
}



export default BookingStatus;
